// ─── App Constants ────────────────────────────────────────────────────────────

export const APP_NAME = "ViralOmics";
export const APP_TAGLINE = "Viral RNA Signature Database";
export const APP_VERSION = "1.0.0";

// ─── Navigation ───────────────────────────────────────────────────────────────

export const NAV_LINKS = [
  { label: "Home", path: "/viralomics" },
  { label: "Database", path: "/viralomics/database" },
  { label: "Tools", path: "/viralomics/tools" },
  { label: "Contact", path: "/viralomics/contact" },
];

// ─── Virus Categories ─────────────────────────────────────────────────────────

export const VIRUS_CATEGORIES = [
  { id: "sars-cov-2", label: "SARS-CoV-2", color: "#FF4D6D" },
  { id: "influenza", label: "Influenza", color: "#4CC9F0" },
  { id: "dengue", label: "Dengue", color: "#F77F00" },
  { id: "ebola", label: "Ebola", color: "#D62828" },
  { id: "zika", label: "Zika", color: "#00B4D8" },
];

// ─── Cell Types ───────────────────────────────────────────────────────────────

export const CELL_TYPES = [
  "A549",
  "HEK293",
  "Calu-3",
  "Vero E6",
  "THP-1",
  "PBMC",
  "HeLa",
  "Huh7",
  "BEAS-2B",
];

// ─── Signaling Types ──────────────────────────────────────────────────────────

export const SIGNALING_TYPES = [
  { id: "autocrine", label: "Autocrine", description: "Same cell line L-R pair" },
  { id: "paracrine", label: "Paracrine", description: "Different cell lines L-R pair" },
];

// ─── Tool Options ─────────────────────────────────────────────────────────────

export const TOOL_MODES = [
  { id: "inflammatory", label: "Inflammatory Signatures", icon: "🔬" },
  { id: "lr_pair", label: "Ligand-Receptor Pair", icon: "🔗" },
  { id: "transmembrane", label: "Transmembrane Protein Classification", icon: "🧬" },
  { id: "cross_data", label: "Cross-Data Combination Analysis", icon: "📊" },
];

// ─── Download Formats ─────────────────────────────────────────────────────────

export const DOWNLOAD_FORMATS = ["CSV", "TSV", "JSON", "Excel (.xlsx)"];

// ─── Stats ────────────────────────────────────────────────────────────────────

export const STATS = [
  { value: "12,480+", label: "Gene Expression Profiles" },
  { value: "48", label: "Viral Strains" },
  { value: "9", label: "Cell Types" },
  { value: "3,200+", label: "L-R Pairs Mapped" },
];

// ─── Services ─────────────────────────────────────────────────────────────────

export const SERVICES = [
  {
    id: 1,
    icon: "🧬",
    title: "Transcriptome Database",
    description:
      "Curated global transcriptome profiles of inflammatory responses to RNA-based viral infections in humans, normalized and annotated using GEO2R and NCBI datasets.",
  },
  {
    id: 2,
    icon: "🔬",
    title: "Inflammatory Signature Analysis",
    description:
      "Identify omics signature profiles of inflammatory responses across viral strains and cell types with pan-signature and hub gene detection.",
  },
  {
    id: 3,
    icon: "🔗",
    title: "Ligand-Receptor Pair Mapping",
    description:
      "Map intra- and inter-cellular signaling via L-R pair analysis. Differentiate autocrine (same cell line) from paracrine (cross cell line) interactions.",
  },
  {
    id: 4,
    icon: "📡",
    title: "Transmembrane Protein Classification",
    description:
      "Classify and visualize transmembrane proteins involved in viral entry and immune evasion with hierarchical signaling pathway context.",
  },
  {
    id: 5,
    icon: "📊",
    title: "Cross-Dataset Combination",
    description:
      "Combine expression datasets within the same infection to derive pan-signatures and identify hub genes across multiple experimental conditions.",
  },
  {
    id: 6,
    icon: "⚙️",
    title: "Systems Biology Tools",
    description:
      "Integrated tools for uploading custom datasets, performing GEO2R-based normalization, and generating publication-ready visualizations.",
  },
];

// ─── Team ─────────────────────────────────────────────────────────────────────

// export const TEAM = [
//   {
//     name: "Dr. Ramesh Babu",
//     role: "Principal Investigator",
//     affiliation: "Dept. of Bioinformatics",
//     img: "https://ui-avatars.com/api/?name=Ramesh+Babu&background=0D1B2A&color=4CC9F0&size=128",
//   },
//   {
//     name: "Dr. Priya Viswanathan",
//     role: "Co-Investigator",
//     affiliation: "Systems Biology Lab",
//     img: "https://ui-avatars.com/api/?name=Priya+V&background=0D1B2A&color=7BF5A8&size=128",
//   },
//   {
//     name: "Arjun Krishnan",
//     role: "Lead Developer",
//     affiliation: "Computational Genomics",
//     img: "https://ui-avatars.com/api/?name=Arjun+K&background=0D1B2A&color=FFB703&size=128",
//   },
//   {
//     name: "Sneha Nair",
//     role: "Data Analyst",
//     affiliation: "Transcriptomics Unit",
//     img: "https://ui-avatars.com/api/?name=Sneha+N&background=0D1B2A&color=FF4D6D&size=128",
//   },
// ];

// ─── Sample Dataset ───────────────────────────────────────────────────────────

// export const SAMPLE_GENE_DATA = [
//   { gene: "IFITM1", logFC: 4.23, pValue: 0.0001, adjP: 0.0003, regulation: "up" },
//   { gene: "MX1", logFC: 3.87, pValue: 0.0002, adjP: 0.0005, regulation: "up" },
//   { gene: "ISG15", logFC: 5.12, pValue: 0.00005, adjP: 0.0001, regulation: "up" },
//   { gene: "OAS1", logFC: 3.56, pValue: 0.0003, adjP: 0.0007, regulation: "up" },
//   { gene: "IFIT1", logFC: 4.78, pValue: 0.0001, adjP: 0.0003, regulation: "up" },
//   { gene: "IL6", logFC: 2.91, pValue: 0.001, adjP: 0.002, regulation: "up" },
//   { gene: "TNF", logFC: 2.34, pValue: 0.005, adjP: 0.009, regulation: "up" },
//   { gene: "ACE2", logFC: -1.87, pValue: 0.01, adjP: 0.02, regulation: "down" },
//   { gene: "TMPRSS2", logFC: -2.12, pValue: 0.008, adjP: 0.015, regulation: "down" },
//   { gene: "IRF3", logFC: 1.65, pValue: 0.02, adjP: 0.04, regulation: "up" },
// ];

// export const SAMPLE_LR_DATA = [
//   { ligand: "IFNG", receptor: "IFNGR1", cellType: "THP-1", type: "paracrine", score: 0.92 },
//   { ligand: "IL6", receptor: "IL6R", cellType: "A549", type: "autocrine", score: 0.88 },
//   { ligand: "TNF", receptor: "TNFR1", cellType: "PBMC", type: "paracrine", score: 0.85 },
//   { ligand: "CCL2", receptor: "CCR2", cellType: "HEK293", type: "paracrine", score: 0.79 },
//   { ligand: "CXCL10", receptor: "CXCR3", cellType: "Calu-3", type: "autocrine", score: 0.76 },
// ];